import React from 'react';
import { MarginStyle } from './Styled';

export interface MarginProps {
  left?: number;
  top?: number;
  right?: number;
  bottom?: number;
}

const Margin = (props: MarginProps) => {
  const { left, top, right, bottom } = props;

  return <MarginStyle theme={{ left, top, right, bottom }} className="product-review-margin" />;
};

Margin.defaultProps = {
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
};

export default Margin;
export { Margin };
